const globalErrorHandler = (err: any, reject: (reason?: any) => void) => {
    console.log(`An api error occurred: ${err.response?.data.message || "An unknown error has occurred"}`)
    reject(err.response?.data.message || "An unknown error has occurred")
}
export default globalErrorHandler